module.exports = __webpack_public_path__ + "media/images/pic/family-3-a48a4eb0bb7e9d1b94beb8825d2c23cc.jpeg";